import styled from 'styled-components';

export const MenuContainer = styled.div`
  margin-top: 150px;
`;
export const ActiveStateIndicator = styled.div<{ show: boolean }>`
  opacity: ${({ show }) => (show ? 1 : 0)};
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  &:before {
    width: 4px;
    background: ${({ theme }) => theme.colors.primary};
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
  }
  &:after {
    content: '';
    background: ${({ theme }) => theme.colors.primary};
    opacity: 0.3;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
`;

export const MenuItem = styled.div`
  cursor: pointer;
  line-height: 1;
  padding: 10px 120px 8px 30px;
  position: relative;
  a {
    text-decoration: none;
    color: black;
  }

  &:hover ${ActiveStateIndicator} {
    opacity: 1;
  }
`;
